export const translations = {
  de: {
    header: {
      home: 'Home',
      aboutUs: 'Über uns',
      whyGoldSilver: 'Warum Gold & Silber',
      products: 'Produkte',
      priceList: 'Preisliste',
      contact: 'Kontakt'
    },
    common: {
      contactUs: 'Kontaktieren Sie uns',
      viewProducts: 'Produkte ansehen'
    },
    cookie: {
      message: 'Wir verwenden Cookies, um Ihre Erfahrung auf unserer Website zu verbessern. Durch die Nutzung unserer Website stimmen Sie unserer',
      privacyPolicy: 'Datenschutzerklärung',
      accept: 'Akzeptieren',
      decline: 'Ablehnen'
    },
    home: {
      hero: {
        headline: 'Verwirklichen Sie Ihre Träume von morgen, mit Ihrem Goldkauf von heute',
        subheadline: 'Sichern Sie Ihr Vermögen mit physischem Gold und Silber – transparent, zertifiziert und diskret',
        quote: '»Es kommt nicht darauf an, die Zukunft vorauszusagen, sondern auf die Zukunft vorbereitet zu sein.«',
        quoteAuthor: 'Perykles (500–429 v. Chr.)'
      },
      trust: {
        title: 'Warum GOLD DREAMS?',
        transparency: {
          title: 'Transparenz',
          description: 'Faire Preise ohne versteckte Kosten. Sie sehen jederzeit den aktuellen Preis.'
        },
        quality: {
          title: 'Zertifizierte Qualität',
          description: 'Alle Produkte sind LBMA-zertifiziert und entsprechen höchsten Qualitätsstandards. Hergestellt in Deutschland mit einer Reinheit von 999.9/1000.'
        },
        security: {
          title: 'Sicher & diskret',
          description: 'Versicherter Versand und diskrete Verpackung. Ihre Privatsphäre und Sicherheit haben oberste Priorität.'
        },
        consultation: {
          title: 'Persönliche Beratung',
          description: 'Unser Expertenteam berät Sie individuell zu Ihrer Strategie und begleitet Sie auf Ihrem Weg zur finanziellen Sicherheit.'
        }
      },
      process: {
        title: 'So funktioniert es',
        subtitle: 'Ihr Weg zur finanziellen Sicherheit in 3 einfachen Schritten',
        step1: {
          title: 'Beratung & Auswahl',
          description: 'Vereinbaren Sie einen kostenlosen Beratungstermin. Gemeinsam finden wir die richtige Strategie für Ihre Ziele und wählen die optimalen Produkte aus.'
        },
        step2: {
          title: 'Kontaktaufnahme',
          description: 'Kontaktieren Sie uns bequem per Telefon, E-Mail oder Nachricht. Wir garantieren aktuelle Preise und transparente Abwicklung ohne versteckte Gebühren.'
        },
        step3: {
          title: 'Lieferung',
          description: 'Ihre Edelmetalle werden versichert und diskret verpackt direkt zu Ihnen nach Hause geliefert.'
        }
      },
      products: {
        title: 'Unsere Sparplanmöglichkeiten',
        subtitle: 'Wählen Sie die passende Option für Ihre Strategie',
        popular: 'Beliebt',
        savingsPlan: {
          badge: 'Sparplan',
          title: 'Monatliche Sparpläne',
          description: 'Bauen Sie systematisch Vermögen auf mit flexiblen monatlichen Beträgen in Gold und Silber.',
          priceLabel: 'Ab',
          priceAmount: '50€/Monat',
          feature1: 'Flexibel sparen ab 50€ monatlich',
          feature2: 'Automatischer Kauf zum aktuellen Preis',
          feature3: 'Jederzeit anpassbar oder kündbar',
          feature4: 'Premium-Versand versichert',
          feature5: 'Persönliche Beratung inklusive',
          cta: 'Jetzt kontaktieren'
        },
        oneTime: {
          badge: 'Einmalbestellung',
          title: 'Einmalbestellungen',
          description: 'Tauschen Sie gezielt in Goldbarren, Silberbarren oder Münzen. Große Auswahl an LBMA-zertifizierten Produkten.',
          priceLabel: 'Ab',
          priceAmount: '500€',
          feature1: 'LBMA-zertifizierte Produkte',
          feature2: 'Hergestellt in Deutschland',
          feature3: 'Versicherter Versand',
          feature4: 'Premium-Versand versichert',
          feature5: 'Persönliche Beratung inklusive',
          cta: 'Jetzt kontaktieren'
        }
      },
      cta: {
        title: 'Bereit in Edelmetalle anzulegen?',
        description: 'Starten Sie noch heute Ihren Weg zur finanziellen Sicherheit. Unsere Experten sind für Sie da.',
        button: 'Kostenlose Beratung erhalten'
      }
    },
    products: {
      title: 'Unsere Produkte',
      subtitle: 'Hochwertige Edelmetalle für Ihre Geldanlage',
      savingsPlan: {
        title: 'Gold- & Silber-Sparpläne',
        description: 'Bauen Sie systematisch Vermögen auf mit flexiblen monatlichen Beträgen in Gold und Silber.',
        priceFrom: 'Ab 50€/Monat',
        feature1: 'Flexible monatliche Raten',
        feature2: 'Cost-Average-Effekt',
        feature3: 'Jederzeit kündbar',
        feature4: 'Kostenlose Depotverwaltung',
        feature5: 'Persönliche Beratung inklusive',
        cta: 'Jetzt kontaktieren'
      },
      oneTime: {
        title: 'Einmalbestellungen Edelmetalle',
        description: 'Gezielt investieren in Goldbarren, Silberbarren oder Münzen. Große Auswahl an LBMA-zertifizierten Produkten.',
        priceFrom: 'Ab 500€',
        feature1: 'LBMA-zertifizierte Produkte',
        feature2: 'Hergestellt in Deutschland',
        feature3: 'Versicherter Versand',
        feature4: 'Rückkaufgarantie',
        feature5: 'Persönliche Beratung inklusive',
        cta: 'Jetzt kontaktieren'
      },
      certification: {
        title: 'LBMA-Zertifizierung',
        description: 'Alle unsere Produkte erfüllen den LBMA Good Delivery Standard – das weltweit anerkannte Qualitätssiegel für Edelmetalle.'
      },
      buyback: {
        title: 'Rückkaufgarantie',
        description: 'Wir garantieren den Rückkauf Ihrer bei uns erworbenen Edelmetalle zu unseren Tagespreisen. Ihre Investition bleibt liquide und flexibel verfügbar.'
      },
      contactNote: {
        title: 'Interesse an unseren Produkten?',
        description: 'Kontaktieren Sie uns telefonisch, per E-Mail oder über das Kontaktformular, um eine Bestellung aufzugeben oder eine persönliche Beratung zu erhalten.',
        phone: 'Telefon',
        email: 'E-Mail',
        form: 'Kontaktformular'
      },
      pageTitle: 'Unsere Produkte',
      metalHighlights: {
        gold: {
          metal: 'Gold',
          purity: '999.9/1000 (99,9% reines Gold)',
          imageAlt: 'Nahaufnahme von kleinen Goldbarren bis maximal 200g'
        },
        silver: {
          metal: 'Silber',
          purity: '999.9/1000 (99,9% reines Silber)',
          imageAlt: 'Silberbarren füllen das gesamte Bild'
        }
      },
      availableWeights: 'Verfügbare Gewichte:',
      purityLabel: 'Reinheit:',
      priceList: 'Preisliste',
      certificationSection: {
        title: 'Qualität und Zertifizierung'
      },
      certifications: {
        madeInGermany: {
          title: 'Made in Germany',
          description: 'Alle Produkte werden in Deutschland nach höchsten Qualitätsstandards hergestellt'
        },
        lbmaCertified: {
          title: 'LBMA-zertifiziert',
          description: 'Erfüllt den LBMA Good Delivery Standard für internationale Anerkennung'
        },
        authenticityCertificate: {
          title: 'Echtheitszertifikat',
          description: 'Jedes Produkt wird mit einem offiziellen Echtheitszertifikat geliefert'
        }
      },
      infoBox: {
        title: 'Rückkaufgarantie',
        description: 'Wir garantieren den Rückkauf Ihrer bei uns erworbenen Edelmetalle zu unseren Tagespreisen. Ihre Investition bleibt liquide und flexibel verfügbar.'
      }
    },
    priceList: {
      title: 'Aktuelle Preisliste',
      subtitle: 'Transparente Preise für Gold und Silber – täglich aktualisiert',
      table: {
        product: 'Produkt',
        weight: 'Gewicht',
        purity: 'Reinheit',
        ankauf: 'Ankauf (Netto)',
        verkaufNetto: 'Verkauf (Netto)',
        verkaufBrutto: 'Verkauf (Brutto)',
        contact: 'Kontakt'
      },
      goldBars: 'Goldbarren',
      silverBars: 'Silberbarren',
      lastUpdated: 'Zuletzt aktualisiert',
      contactNote: 'Für Bestellungen kontaktieren Sie uns bitte per Telefon unter +49 (0) 6359 86762 / +49 (0) 172 297 30 22, per Email an info@golddreams.eu oder über das Kontaktformular.',
      features: {
        quality: {
          title: 'LBMA-zertifizierte Qualität',
          description: 'Alle unsere Produkte erfüllen den LBMA Good Delivery Standard und werden in Deutschland hergestellt.'
        },
        daily: {
          title: 'Täglich aktualisierte Preise',
          description: 'Unsere Preise werden täglich angepasst. Sie erhalten immer faire und transparente Konditionen.'
        },
        buyback: {
          title: 'Rückkaufgarantie',
          description: 'Wir kaufen Ihre Edelmetalle jederzeit zu unseren Tagespreisen zurück.'
        }
      },
      cta: {
        title: 'Bereit zu investieren?',
        description: 'Kontaktieren Sie uns für aktuelle Preise und eine persönliche Beratung.',
        button1: 'Jetzt kontaktieren',
        button2: 'Produkte ansehen'
      }
    },
    whyGoldSilver: {
      title: 'Warum Gold & Silber?',
      intro: {
        description: 'Gold und Silber sind seit Jahrtausenden bewährte Wertspeicher und bieten Schutz vor Inflation und Wirtschaftskrisen.',
        highlight: 'Jede irdische Macht vergeht – der Wert von Gold und Silber bleibt.'
      },
      example: {
        title: 'Beispiel eines Sparplans',
        trendRising: 'Trend steigend',
        investmentTitle: 'Investition in Gold seit 1999',
        investmentPeriod: 'über einen Zeitraum von 26 Jahren mit nur 100 € monatlich',
        goldAmount: 'Heute hätten Sie 1,5 kg Gold zu Hause.',
        totalInvestment: 'Gesamtinvestition',
        totalInvestmentValue: 'ca. 30.000 €',
        currentValue: 'Aktueller Wert',
        currentValueAmount: 'ca. 215.000 €',
        asOf: 'Stand: Januar 2025. Historische Wertentwicklung ist keine Garantie für zukünftige Erträge.'
      },
      historical: {
        title: 'Historische Preisentwicklung',
        subtitle: 'Vergleich der Goldpreise von 1999 bis 2025',
        pricePerKg: 'Preis pro kg (€)',
        gold: 'Gold',
        silver: 'Silber'
      },
      calculator: {
        title: 'Sparplanrechner',
        subtitle: 'Berechnen Sie Ihre potenzielle Rendite',
        investment: 'Investitionsbetrag',
        period: 'Anlagezeitraum',
        years: 'Jahre',
        calculate: 'Rendite berechnen',
        result: 'Geschätzter Wert nach',
        disclaimer: 'Dies ist eine Schätzung basierend auf historischen Daten. Tatsächliche Renditen können variieren.'
      },
      benefits: {
        title: 'Vorteile von Gold & Silber',
        benefit1: {
          title: 'Inflationsschutz',
          description: 'Gold und Silber behalten ihren Wert auch bei steigender Inflation und schützen Ihr Vermögen.'
        },
        benefit2: {
          title: 'Krisensicher',
          description: 'Edelmetalle sind unabhängig von Banken und Währungen – ein sicherer Hafen in unsicheren Zeiten.'
        },
        benefit3: {
          title: 'Portfoliodiversifikation',
          description: 'Edelmetalle reduzieren das Risiko Ihres Portfolios durch geringe Korrelation zu anderen Anlageklassen.'
        },
        benefit4: {
          title: 'Langfristige Werterhaltung',
          description: 'Gold und Silber haben über Jahrhunderte ihren Wert behalten und sind eine verlässliche Anlage.'
        },
        benefit5: {
          title: 'Physischer Besitz',
          description: 'Sie besitzen echte, greifbare Werte – keine digitalen Versprechen oder Papiergeld.'
        },
        benefit6: {
          title: 'Weltweit anerkannt',
          description: 'Gold und Silber werden überall auf der Welt als Zahlungsmittel und Wertanlage akzeptiert.'
        },
        benefit7: {
          title: 'Steuervorteile',
          description: 'Physisches Gold ist nach einem Jahr Haltedauer steuerfrei – eine attraktive Anlage für langfristige Investoren.'
        }
      },
      cta: {
        title: 'Bereit in Edelmetalle anzulegen?',
        description: 'Kontaktieren Sie uns für aktuelle Preise und eine persönliche Beratung.',
        button: 'Jetzt Beratung vereinbaren',
        button1: 'Jetzt Beratung vereinbaren',
        button2: 'Produkte ansehen'
      }
    },
    news: {
      title: 'Neuigkeiten & Insights',
      subtitle: 'Bleiben Sie informiert über Edelmetallmärkte und Investmentstrategien',
      readTime: 'Min. Lesezeit'
    },
    aboutUs: {
      title: 'Über uns',
      subtitle: 'Ihr vertrauenswürdiger Partner für Edelmetallabsicherung',
      company: {
        title: 'Über GOLD DREAMS',
        description: 'Wir sind ein Unternehmen aus dem Finanzsektor, das sich auf den Verkauf von Anlagegold spezialisiert hat. Unser Angebot richtet sich an Kunden, die nach sicheren und bewährten Möglichkeiten zur Vermögenssicherung und privten Altersvorsorge suchen.\n\nWir legen großen Wert auf Transparenz, Zuverlässigkeit und individuelle Betreuung jedes einzelnen Kunden. Wir unterstützen bei der Auswahl geeigneter Anlageprodukte, die auf die aktuelle Marktsituation und persönliche finanzielle Ziele abgestimmt sind.\n\nWir arbeiten ausschließlich mit renommierten Anbietern zusammen und bieten zertifiziertes Gold höchster Qualität an. Transaktionssicherheit, klare Rahmenbedingungen und absolute Vertraulichkeit haben für uns höchste Priorität.\n\nDurch unsere Erfahrung und laufende Analyse der Finanzmärkte begleiten wir unsere Kunden bei bewussten und durchdachten Investitionsentscheidungen. Unser Ziel ist es, langfristige Geschäftsbeziehungen aufzubauen, die auf Vertrauen und Professionalität basieren.\n\nWir laden Sie ein, Kontakt aufzunehmen – wir beantworten Ihre Fragen und helfen Ihnen, Lösungen zu finden, die auf Ihre individuellen Bedürfnisse zugeschnitten sind.'
      },
      values: {
        title: 'Unsere Werte',
        trust: {
          title: 'Vertrauen und Transparenz',
          description: 'Wir glauben an offene Kommunikation und faire Preise. Keine versteckten Kosten, keine Überraschungen.'
        },
        quality: {
          title: 'Qualität und Zertifizierung',
          description: 'Alle unsere Produkte sind durch LBMA zertifiziert und erfüllen die höchsten internationalen Standards.'
        },
        service: {
          title: 'Service und Beratung',
          description: 'Unsere erfahrenen Experten sind für Sie da, um Ihnen die beste Strategie für Ihre Bedürfnisse zu finden.'
        }
      },
      faq: {
        title: 'Häufig gestellte Fragen',
        q1: {
          question: 'Warum sollte ich in Gold und Silber investieren?',
          answer: 'Gold und Silber sind bewährte Wertspeicher, die vor Inflation und Wirtschaftskrisen schützen. Sie bieten Portfoliodiversifikation und langfristige Werterhaltung.'
        },
        q2: {
          question: 'Was bedeutet LBMA-Zertifizierung?',
          answer: 'Der LBMA (London Bullion Market Association) Good Delivery Standard ist ein weltweit anerkanntes Qualitätssiegel für Edelmetalle. Er garantiert Reinheit, Gewicht und Rückverfolgbarkeit.'
        },
        q3: {
          question: 'Wie funktioniert der Sparplan?',
          answer: 'Mit unserem Sparplan investieren Sie monatlich einen festen Betrag in Gold und/oder Silber. Dies ermöglicht den Cost-Average-Effekt und systematischen Vermögensaufbau.'
        },
        q4: {
          question: 'Kann ich meine Edelmetalle zurückverkaufen?',
          answer: 'Ja, wir bieten eine Rückkaufgarantie zu fairen Tagespreisen. Ihre Investition bleibt liquide und kann jederzeit verkauft werden.'
        }
      },
      cta: 'Contact Us',
      viewProducts: 'View Our Products'
    },
    contact: {
      title: 'Kontaktieren Sie uns',
      subtitle: 'Haben Sie Fragen zu unseren Produkten oder wünschen eine persönliche Beratung? Wir sind für Sie da.',
      form: {
        title: 'Senden Sie uns eine Nachricht',
        name: 'Ihr Name',
        email: 'Ihre E-Mail',
        phone: 'Telefonnummer (optional)',
        subject: 'Betreff',
        message: 'Ihre Nachricht',
        submit: 'Nachricht senden',
        sending: 'Wird gesendet...',
        success: 'Vielen Dank! Wir werden uns in Kürze bei Ihnen melden.',
        error: 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.'
      },
      info: {
        title: 'Kontaktinformationen',
        phone: 'Telefon',
        email: 'E-mail',
        address: 'Adresse',
        hours: 'Öffnungszeiten',
        hoursValue: 'Mo-Fr: 9:00 - 17:00 Uhr'
      },
      trust: {
        fast: {
          title: 'Schnelle Antwort',
          description: 'Wir antworten innerhalb von 24 Stunden auf Ihre Anfrage'
        },
        individual: {
          title: 'Individuelle Beratung',
          description: 'Persönliche Beratung zu Ihren Sparplan-Möglichkeiten'
        },
        competent: {
          title: 'Kompetente Unterstützung',
          description: 'Erfahrene Experten beantworten alle Ihre Fragen'
        }
      }
    },
    footer: {
      company: 'Ihr vertrauenswürdiger Partner für Gold und Silber seit 2010.',
      navigation: 'Navigation',
      services: 'Services',
      copyright: 'Alle Rechte vorbehalten.',
      imprint: 'Impressum',
      contact: 'Kontakt',
      privacy: 'Datenschutz',
      deliveryPayment: 'Liefer- und Zahlungsbedingungen'
    },
    privacy: {
      title: 'Datenschutzerklärung',
      subtitle: 'Ihre Privatsphäre ist uns wichtig. Hier erfahren Sie, wie wir Ihre Daten schützen und verarbeiten.',
      intro: {
        title: 'Einleitung',
        content1: 'Der Schutz Ihrer persönlichen Daten ist uns besonders wichtig. Wir verarbeiten Ihre Daten ausschließlich auf Grundlage der gesetzlichen Bestimmungen (DSGVO, TKG 2003).',
        content2: 'In dieser Datenschutzerklärung informieren wir Sie über die wichtigsten Aspekte der Datenverarbeitung im Rahmen unserer Website und unserer Dienstleistungen.'
      },
      controller: {
        title: 'Verantwortlicher',
        email: 'E-Mail',
        phone: 'Telefon'
      },
      collection: {
        title: 'Welche Daten wir erheben',
        intro: 'Wir erheben und verarbeiten folgende personenbezogene Daten:',
        item1: 'Kontaktdaten (Name, E-Mail-Adresse, Telefonnummer)',
        item2: 'Adressdaten für Lieferungen',
        item3: 'Zahlungsinformationen',
        item4: 'Kommunikationsdaten (Anfragen, Nachrichten)',
        item5: 'Technische Daten (IP-Adresse, Browser-Informationen, Zugriffszeiten)'
      },
      purpose: {
        title: 'Zweck der Datenverarbeitung',
        intro: 'Wir verwenden Ihre Daten für folgende Zwecke:',
        item1: 'Abwicklung von Bestellungen und Verträgen',
        item2: 'Kundenservice und Beantwortung von Anfragen',
        item3: 'Versand von Produkten',
        item4: 'Erfüllung gesetzlicher Verpflichtungen',
        item5: 'Verbesserung unserer Dienstleistungen'
      },
      legal: {
        title: 'Rechtsgrundlage',
        content1: 'Die Verarbeitung Ihrer Daten erfolgt auf Grundlage von Art. 6 Abs. 1 DSGVO:',
        content2: 'a) Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) – Sie haben uns Ihre ausdrückliche Einwilligung zur Verarbeitung erteilt.',
        content3: 'b) Vertragserfüllung (Art. 6 Abs. 1 lit. b DSGVO) – Die Verarbeitung ist zur Erfüllung eines Vertrags erforderlich.'
      },
      retention: {
        title: 'Speicherdauer',
        content1: 'Wir speichern Ihre personenbezogenen Daten nur so lange, wie dies zur Erfüllung der jeweiligen Zwecke oder zur Einhaltung gesetzlicher Aufbewahrungsfristen erforderlich ist.',
        content2: 'Nach Ablauf dieser Fristen werden die Daten routinemäßig gelöscht, sofern keine weitere Verarbeitung erforderlich ist.'
      },
      rights: {
        title: 'Ihre Rechte',
        intro: 'Sie haben folgende Rechte bezüglich Ihrer personenbezogenen Daten:',
        access: 'Auskunftsrecht',
        accessDesc: 'Sie haben das Recht, Auskunft über Ihre gespeicherten Daten zu erhalten.',
        rectification: 'Recht auf Berichtigung',
        rectificationDesc: 'Sie können die Korrektur unrichtiger Daten verlangen.',
        erasure: 'Recht auf Löschung',
        erasureDesc: 'Sie können die Löschung Ihrer Daten verlangen, sofern keine gesetzlichen Aufbewahrungspflichten bestehen.',
        restriction: 'Einschränkung der Verarbeitung',
        restrictionDesc: 'Sie können die Einschränkung der Verarbeitung Ihrer Daten verlangen.',
        portability: 'Datenübertragbarkeit',
        portabilityDesc: 'Sie haben das Recht, Ihre Daten in einem strukturierten Format zu erhalten.',
        objection: 'Widerspruchsrecht',
        objectionDesc: 'Sie können der Verarbeitung Ihrer Daten widersprechen.'
      },
      security: {
        title: 'Datensicherheit',
        content1: 'Wir setzen geeignete technische und organisatorische Sicherheitsmaßnahmen ein, um Ihre Daten vor zufälliger oder vorsätzlicher Manipulation, Verlust, Zerstörung oder dem Zugriff unberechtigter Personen zu schützen.',
        content2: 'Unsere Sicherheitsmaßnahmen werden entsprechend der technologischen Entwicklung fortlaufend verbessert.'
      },
      cookies: {
        title: 'Cookies',
        content1: 'Unsere Website verwendet Cookies, um die Benutzerfreundlichkeit zu verbessern. Cookies sind kleine Textdateien, die auf Ihrem Gerät gespeichert werden.',
        content2: 'Sie können Ihren Browser so konfigurieren, dass er Sie über das Setzen von Cookies informiert und Cookies nur im Einzelfall erlaubt oder die Annahme von Cookies generell ausschließt.'
      },
      contact: {
        title: 'Kontakt',
        content: 'Bei Fragen zum Datenschutz können Sie sich jederzeit an uns wenden:'
      },
      lastUpdated: 'Letzte Aktualisierung'
    },
    deliveryAndPayment: {
      title: 'Liefer- und Zahlungsbedingungen',
      section1: {
        title: '1. Geltungsbereich',
        content: 'Diese Liefer- und Zahlungsbedingungen gelten für alle Bestellungen von Edelmetallen (Gold und Silber) bei GOLD DREAMS. Mit der Aufgabe einer Bestellung erkennen Sie diese Bedingungen als verbindlich an.'
      },
      section2: {
        title: '2. Bestellung und Vertragsabschluss',
        content1: 'Bestellungen können telefonisch unter +49 (0) 6359 86762 / +49 (0) 172 297 30 22, per E-Mail an info@golddreams.eu oder über unser Kontaktformular aufgegeben werden.',
        content2: 'Nach Eingang Ihrer Bestellung erhalten Sie eine Auftragsbestätigung per E-Mail. Der Vertrag kommt mit Versand dieser Bestätigung zustande.',
        content3: 'Die angegebenen Preise basieren auf dem aktuellen Marktpreis zum Zeitpunkt der Bestellung und verstehen sich zzgl. der gesetzlichen Mehrwertsteuer.'
      },
      section3: {
        title: '3. Preise',
        content: 'Alle Preise werden täglich aktualisiert und basieren auf dem aktuellen Gold- oder Silberpreis. Die zum Zeitpunkt der Bestellung gültigen Preise sind verbindlich. Die Preise sind in Euro angegeben und enthalten die gesetzliche Mehrwertsteuer.'
      },
      section4: {
        title: '4. Zahlungsbedingungen',
        content1: 'Wir akzeptieren folgende Zahlungsmethoden:',
        item1: 'Banküberweisung (Vorkasse)',
        item2: 'Barzahlung bei Abholung (nach Vereinbarung)',
        content2: 'Die Lieferung erfolgt erst nach Eingang der vollständigen Zahlung auf unserem Konto.'
      },
      section5: {
        title: '5. Lieferung und Versand',
        content1: 'Die Lieferung erfolgt versichert und diskret verpackt an die von Ihnen angegebene Lieferadresse. Die Lieferzeit beträgt in der Regel 3-5 Werktage nach Zahlungseingang.',
        content2: 'Die Versandkosten sind im Produktpreis enthalten. Bei größeren Bestellungen oder Sparplänen ist der Versand kostenlos.'
      },
      section6: {
        title: '6. Rückkaufgarantie',
        content1: 'Wir garantieren den Rückkauf aller bei uns erworbenen Edelmetalle zu unseren aktuellen Tagespreisen.',
        content2: 'Kontaktieren Sie uns für ein unverbindliches Rückkaufangebot.'
      },
      section7: {
        title: '7. Haftung und Gewährleistung',
        content: 'Alle Produkte sind LBMA-zertifiziert und werden mit einem Echtheitszertifikat geliefert. Wir haften für Material- und Herstellungsfehler gemäß den gesetzlichen Bestimmungen. Reklamationen sind unverzüglich nach Erhalt der Ware schriftlich anzuzeigen.'
      }
    },
    imprint: {
      title: 'Impressum',
      section1: {
        title: 'Angaben gemäß § 5 TMG',
        company: 'GOLD DREAMS',
        legalForm: 'Einzelunternehmen',
        address: 'Hauptstraße 123',
        city: '67346 Speyer',
        country: 'Deutschland'
      },
      section2: {
        title: 'Kontakt',
        phone: 'Telefon',
        phoneValue: '+49 (0) 6359 86762',
        mobile: 'Mobil',
        mobileValue: '+49 (0) 172 297 30 22',
        email: 'E-Mail',
        emailValue: 'info@golddreams.eu'
      },
      section3: {
        title: 'Umsatzsteuer-ID',
        content: 'Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz:',
        vatId: ''
      },
      section4: {
        title: 'Berufsbezeichnung',
        profession: 'Berufsbezeichnung',
        professionValue: 'Edelmetallhändler',
        country: 'Verliehen in',
        countryValue: 'Deutschland'
      },
      section5: {
        title: 'EU-Streitschlichtung',
        content: 'Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:',
        link: 'https://ec.europa.eu/consumers/odr',
        email: 'Unsere E-Mail-Adresse finden Sie oben im Impressum.'
      },
      section6: {
        title: 'Verbraucherstreitbeilegung',
        content: 'Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.'
      }
    }
  },
  pl: {
    header: {
      home: 'Strona główna',
      aboutUs: 'O nas',
      whyGoldSilver: 'Dlaczego złoto i srebro',
      products: 'Produkty',
      priceList: 'Cennik',
      contact: 'Kontakt'
    },
    common: {
      contactUs: 'Skontaktuj się z nami',
      viewProducts: 'Zobacz produkty'
    },
    cookie: {
      message: 'Używamy plików cookie, aby poprawić Twoje doświadczenia na naszej stronie. Korzystając z naszej strony, zgadzasz się z naszą',
      privacyPolicy: 'Polityką prywatności',
      accept: 'Akceptuj',
      decline: 'Odrzuć'
    },
    home: {
      hero: {
        headline: 'Zrealizuj swoje marzenia o jutrze, dzięki zakupowi złota dzisiaj',
        subheadline: 'Zabezpiecz swój majątek fizycznym złotem i srebrem – przejrzyście, certyfikowane i dyskretnie',
        quote: '»Nie chodzi o przewidywanie przyszłości, ale o bycie na nią przygotowanym.«',
        quoteAuthor: 'Perykles (500–429 p.n.e.)'
      },
      trust: {
        title: 'Dlaczego GOLD DREAMS?',
        transparency: {
          title: 'Przejrzystość',
          description: 'Uczciwe ceny bez ukrytych kosztów. Zawsze widzisz aktualną cenę.'
        },
        quality: {
          title: 'Certyfikowana jakość',
          description: 'Wszystkie produkty są certyfikowane przez LBMA i spełniają najwyższe standardy jakości. Wyprodukowane w Niemczech z czystością 999.9/1000.'
        },
        security: {
          title: 'Bezpieczne i dyskretne',
          description: 'Ubezpieczona wysyłka i dyskretne opakowanie. Twoja prywatność i bezpieczeństwo są najwyższym priorytetem.'
        },
        consultation: {
          title: 'Osobista konsultacja',
          description: 'Nasz zespół ekspertów doradzi Ci indywidualnie w zakresie Twojej strategii i będzie Cię wspierać na drodze do bezpieczeństwa finansowego.'
        }
      },
      process: {
        title: 'Jak to działa',
        subtitle: 'Twoja droga do bezpieczeństwa finansowego w 3 prostych krokach',
        step1: {
          title: 'Konsultacja i wybór',
          description: 'Umów się na bezpłatną konsultację. Wspólnie znajdziemy odpowiednią strategię dla Twoich celów i wybierzemy optymalne produkty.'
        },
        step2: {
          title: 'Kontakt',
          description: 'Skontaktuj się z nami wygodnie przez telefon, e-mail lub wiadomość. Gwarantujemy aktualne ceny i przejrzystą realizację bez ukrytych opłat.'
        },
        step3: {
          title: 'Dostawa',
          description: 'Twoje metale szlachetne zostaną ubezpieczone i dyskretnie zapakowane, a następnie dostarczone bezpośrednio do Twojego domu.'
        }
      },
      products: {
        title: 'Nasze możliwości oszczędzania',
        subtitle: 'Wybierz odpowiednią opcję dla swojej strategii',
        popular: 'Popularne',
        savingsPlan: {
          badge: 'Plan oszczędnościowy',
          title: 'Miesięczne plany oszczędnościowe',
          description: 'Systematycznie buduj majątek dzięki elastycznym miesięcznym kwotom w złocie i srebrze.',
          priceLabel: 'Od',
          priceAmount: '50€/miesiąc',
          feature1: 'Elastyczne oszczędzanie od 50€ miesięcznie',
          feature2: 'Automatyczny zakup po aktualnej cenie',
          feature3: 'Możliwość zmiany lub anulowania w dowolnym momencie',
          feature4: 'Bezpłatne zarządzanie depozytem',
          feature5: 'Osobiste doradztwo w cenie',
          cta: 'Skontaktuj się teraz'
        },
        oneTime: {
          badge: 'Jednorazowe zamówienie',
          title: 'Jednorazowe zamówienia',
          description: 'Celowo inwestuj w sztabki złota, sztabki srebra lub monety. Duży wybór produktów certyfikowanych przez LBMA.',
          priceLabel: 'Od',
          priceAmount: '500€',
          feature1: 'Produkty certyfikowane przez LBMA',
          feature2: 'Wyprodukowane w Niemczech',
          feature3: 'Ubezpieczona wysyłka',
          feature4: 'Gwarancja odkupu',
          feature5: 'Osobiste doradztwo w cenie',
          cta: 'Skontaktuj się teraz'
        }
      },
      cta: {
        title: 'Gotowy, aby rozpocząć plan oszczędzania.',
        description: 'Skontaktuj się z nami, aby uzyskać osobistą konsultację i dowiedzieć się, jak zabezpieczyć swój majątek złotem i srebrem.',
        button: 'Umów się na konsultację'
      }
    },
    whyGoldSilver: {
      title: 'Dlaczego złoto i srebro?',
      intro: {
        description: 'Złoto i srebro są sprawdzonymi środkami przechowywania wartości od tysięcy lat i oferują ochronę przed inflacją i kryzysami gospodarczymi.',
        highlight: 'Każda ziemska władza przemija – wartość złota i srebra pozostaje.'
      },
      example: {
        title: 'Przykład planu oszczędnościowego',
        trendRising: 'Trend rosnący',
        investmentTitle: 'Inwestycja w złoto od 1999 roku',
        investmentPeriod: 'przez okres 26 lat z zaledwie 100 € miesięcznie',
        goldAmount: 'Dziś miałbyś w domu 1,5 kg złota.',
        totalInvestment: 'Całkowita inwestycja',
        totalInvestmentValue: 'ok. 30.000 €',
        currentValue: 'Aktualna wartość',
        currentValueAmount: 'ok. 215.000 €',
        asOf: 'Stan: styczeń 2025. Historyczne wyniki nie gwarantują przyszłych zysków.'
      },
      historical: {
        title: 'Historyczny rozwój cen',
        subtitle: 'Porównanie cen złota od 1999 do 2025',
        pricePerKg: 'Cena za kg (€)',
        gold: 'Złoto',
        silver: 'Srebro'
      },
      calculator: {
        title: 'Kalkulator oszczędnościowy',
        subtitle: 'Oblicz swój potencjalny zwrot',
        investment: 'Kwota inwestycji',
        period: 'Okres inwestycji',
        years: 'lat',
        calculate: 'Oblicz zwrot',
        result: 'Szacowana wartość po',
        disclaimer: 'To jest szacunek oparty na danych historycznych. Rzeczywiste zwroty mogą się różnić.'
      },
      benefits: {
        title: 'Korzyści z złota i srebra',
        benefit1: {
          title: 'Ochrona przed inflacją',
          description: 'Złoto i srebro zachowują swoją wartość nawet przy rosnącej inflacji i chronią Twój majątek.'
        },
        benefit2: {
          title: 'Bezpieczne w kryzysie',
          description: 'Metale szlachetne są niezależne od banków i walut – bezpieczna przystań w niepewnych czasach.'
        },
        benefit3: {
          title: 'Dywersyfikacja portfela',
          description: 'Metale szlachetne zmniejszają ryzyko Twojego portfela dzięki niskiej korelacji z innymi klasami aktywów.'
        },
        benefit4: {
          title: 'Długoterminowe zachowanie wartości',
          description: 'Złoto i srebro zachowały swoją wartość przez wieki i są niezawodną inwestycją.'
        },
        benefit5: {
          title: 'Fizyczna własność',
          description: 'Posiadasz prawdziwe, namacalne wartości – nie cyfrowe obietnice ani pieniądze papierowe.'
        },
        benefit6: {
          title: 'Uznawane na całym świecie',
          description: 'Złoto i srebro są akceptowane na całym świecie jako środek płatniczy i inwestycja.'
        },
        benefit7: {
          title: 'Korzyści podatkowe',
          description: 'Fizyczne złoto jest zwolnione z podatku po roku posiadania – atrakcyjna inwestycja dla długoterminowych inwestorów.'
        }
      },
      cta: {
        title: 'Gotowy zainwestować w metale szlachetne?',
        description: 'Skontaktuj się z nami, aby uzyskać aktualne ceny i osobistą konsultację.',
        button: 'Umów się na konsultację',
        button1: 'Skontaktuj się teraz',
        button2: 'Zobacz produkty'
      }
    },
    priceList: {
      title: 'Aktualna lista cen',
      subtitle: 'Przejrzyste ceny złota i srebra – codziennie aktualizowane',
      table: {
        product: 'Produkt',
        weight: 'Waga',
        purity: 'Czystość',
        ankauf: 'Skup (Netto)',
        verkaufNetto: 'Sprzedaż (Netto)',
        verkaufBrutto: 'Sprzedaż (Brutto)',
        contact: 'Kontakt'
      },
      goldBars: 'Sztabki złota',
      silverBars: 'Sztabki srebra',
      lastUpdated: 'Ostatnia aktualizacja',
      contactNote: 'W celu złożenia zamówienia prosimy o kontakt telefoniczny pod numerem +49 (0) 6359 86762 / +49 (0) 172 297 30 22, e-mailem na info@golddreams.eu lub za pomocą formularza kontaktowego.',
      features: {
        quality: {
          title: 'Jakość certyfikowana przez LBMA',
          description: 'Wszystkie nasze produkty spełniają standard LBMA Good Delivery i są produkowane w Niemczech.'
        },
        daily: {
          title: 'Codziennie aktualizowane ceny',
          description: 'Nasze ceny są codziennie dostosowywane. Zawsze otrzymujesz uczciwe i przejrzyste warunki.'
        },
        buyback: {
          title: 'Gwarancja odkupu',
          description: 'Odkupujemy Twoje metale szlachetne w każdej chwili po naszych cenach dziennych.'
        }
      },
      cta: {
        title: 'Gotowy do inwestycji?',
        description: 'Skontaktuj się z nami, aby uzyskać aktualne ceny i osobistą konsultację.',
        button1: 'Skontaktuj się teraz',
        button2: 'Zobacz produkty'
      }
    },
    products: {
      title: 'Nasze produkty',
      subtitle: 'Wysokiej jakości metale szlachetne dla Twojej inwestycji',
      savingsPlan: {
        title: 'Plany oszczędnościowe złota i srebra',
        description: 'Systematycznie buduj majątek dzięki miesięcznym ratom oszczędnościowym. Elastycznie, przejrzyście i dostosowane do Twoich potrzeb.',
        priceFrom: 'Od 50€/miesiąc',
        feature1: 'Elastyczne miesięczne raty',
        feature2: 'Efekt uśredniania kosztów',
        feature3: 'Możliwość anulowania w dowolnym momencie',
        feature4: 'Bezpłatne zarządzanie depozytem',
        feature5: 'Osobiste doradztwo w cenie',
        cta: 'Skontaktuj się teraz'
      },
      oneTime: {
        title: 'Jednorazowe zamówienia metali szlachetnych',
        description: 'Celowo inwestuj w sztabki złota, sztabki srebra lub monety. Duży wybór produktów certyfikowanych przez LBMA.',
        priceFrom: 'Od 500€',
        feature1: 'Produkty certyfikowane przez LBMA',
        feature2: 'Wyprodukowane w Niemczech',
        feature3: 'Ubezpieczona wysyłka',
        feature4: 'Gwarancja odkupu',
        feature5: 'Osobiste doradztwo w cenie',
        cta: 'Skontaktuj się teraz'
      },
      certification: {
        title: 'Certyfikacja LBMA',
        description: 'Wszystkie nasze produkty spełniają standard LBMA Good Delivery – uznawany na całym świecie znak jakości dla metali szlachetnych.'
      },
      buyback: {
        title: 'Gwarancja odkupu',
        description: 'Gwarantujemy odkup metali szlachetnych zakupionych u nas po naszych cenach dziennych. Twoja inwestycja pozostaje płynna i flexibly dostępna w każdym momencie.'
      },
      contactNote: {
        title: 'Zainteresowany naszymi produktami?',
        description: 'Skontaktuj się z nami telefonicznie, per E-Mail lub za pomocą formularza kontaktowego, aby złożyć zamówienie lub otrzymać osobistą konsultację.',
        phone: 'Telefon',
        email: 'E-mail',
        form: 'Formularz kontaktowy'
      },
      pageTitle: 'Nasze produkty',
      metalHighlights: {
        gold: {
          metal: 'Złoto',
          purity: '999.9/1000 (99,9% czystego złota)',
          imageAlt: 'Zbliżenie małych sztabek złota do maksymalnie 200g'
        },
        silver: {
          metal: 'Srebro',
          purity: '999.9/1000 (99,9% czystego srebra)',
          imageAlt: 'Sztabki srebra wypełniające cały obraz'
        }
      },
      availableWeights: 'Dostępne wagi:',
      purityLabel: 'Czystość:',
      priceList: 'Cennik',
      certificationSection: {
        title: 'Jakość i certyfikacja'
      },
      certifications: {
        madeInGermany: {
          title: 'Produkcja niemiecka',
          description: 'Wszystkie produkty są wytwarzane w Niemczech zgodnie z najwyższymi standardami jakości'
        },
        lbmaCertified: {
          title: 'Certyfikat LBMA',
          description: 'Spełnia standard LBMA Good Delivery dla międzynarodowego uznania'
        },
        authenticityCertificate: {
          title: 'Certyfikat autentyczności',
          description: 'Każdy produkt jest dostarczany z oficjalnym certyfikatem autentyczności'
        }
      },
      infoBox: {
        title: 'Gwarancja odkupu',
        description: 'Gwarantujemy odkup metali szlachetnych zakupionych u nas po naszych cenach dziennych. Twoja inwestycja pozostaje płynna i elastycznie dostępna w każdym momencie.'
      }
    },
    aboutUs: {
      title: 'O nas',
      subtitle: 'Twój zaufany partner w zabezpieczaniu metalami szlachetnymi',
      company: {
        title: 'O GOLD DREAMS',
        description: 'Jesteśmy firmą z sektora finansowego specjalizującą się w sprzedaży złota inwestycyjnego. Nasza oferta skierowana jest do klientów poszukujących bezpiecznych i sprawdzonych sposobów zabezpieczenia majątku i prywatnej emerytury.\n\nPrzywiązujemy dużą wagę do przejrzystości, niezawodności i indywidualnej obsługi każdego klienta. Wspieramy w wyborze odpowiednich produktów inwestycyjnych dostosowanych do aktualnej sytuacji rynkowej i osobistych celów finansowych.\n\nWspółpracujemy wyłącznie z renomowanymi dostawcami i oferujemy certyfikowane złoto najwyższej jakości. Bezpieczeństwo transakcji, jasne warunki i absolutna poufność są dla nas najwyższym priorytetem.\n\nDzięki naszemu doświadczeniu i bieżącej analizie rynków finansowych towarzyszymy naszym klientom w świadomych i przemyślanych decyzjach inwestycyjnych. Naszym celem jest budowanie długoterminowych relacji biznesowych opartych na zaufaniu i profesjonalizmie.\n\nZapraszamy do kontaktu – odpowiemy na Twoje pytania i pomożemy znaleźć rozwiązania dostosowane do Twoich indywidualnych potrzeb.'
      },
      values: {
        title: 'Nasze wartości',
        trust: {
          title: 'Zaufanie i przejrzystość',
          description: 'Wierzymy w otwartą komunikację i uczciwe ceny. Bez ukrytych kosztów, bez niespodzianek.'
        },
        quality: {
          title: 'Jakość i certyfikacja',
          description: 'Wszystkie nasze produkty są certyfikowane przez LBMA i spełniają najwyższe międzynarodowe standardy.'
        },
        service: {
          title: 'Obsługa i doradztwo',
          description: 'Nasi doświadczeni eksperci są do Twojej dyspozycji, aby pomóc Ci znaleźć najlepszą strategię dla Twoich potrzeb.'
        }
      },
      faq: {
        title: 'Najczęściej zadawane pytania',
        q1: {
          question: 'Dlaczego powinienem inwestować w złoto i srebro?',
          answer: 'Złoto i srebro to sprawdzone środki przechowywania wartości, które chronią przed inflacją i kryzysami gospodarczymi. Oferują dywersyfikację portfela i długoterminowe zachowanie wartości.'
        },
        q2: {
          question: 'Co oznacza certyfikacja LBMA?',
          answer: 'Standard LBMA (London Bullion Market Association) Good Delivery to uznawany na całym świecie znak jakości dla metali szlachetnych. Gwarantuje czystość, wagę i możliwość śledzenia pochodzenia.'
        },
        q3: {
          question: 'Jak działa plan oszczędnościowy?',
          answer: 'Dzięki naszemu planowi oszczędnościowemu inwestujesz miesięcznie stałą kwotę w złoto i/lub srebro. Umożliwia to efekt uśredniania kosztów i systematyczne budowanie majątku.'
        },
        q4: {
          question: 'Czy mogę odsprzedać swoje metale szlachetne?',
          answer: 'Tak, oferujemy gwarancję odkupu po uczciwych cenach dziennych. Twoja inwestycja pozostaje płynna i może być sprzedana w dowolnym momencie.'
        }
      },
      cta: 'Contact Us',
      viewProducts: 'View Our Products'
    },
    contact: {
      title: 'Skontaktuj się z nami',
      subtitle: 'Jesteśmy tu dla Ciebie',
      form: {
        title: 'Wyślij nam wiadomość',
        name: 'Twoje imię',
        email: 'Twój e-mail',
        phone: 'Numer telefonu (opcjonalnie)',
        subject: 'Temat',
        message: 'Twoja wiadomość',
        submit: 'Wyślij wiadomość',
        sending: 'Wysyłanie...',
        success: 'Dziękujemy! Wkrótce się z Tobą skontaktujemy.',
        error: 'Wystąpił błąd. Spróbuj ponownie.'
      },
      info: {
        title: 'Informacje kontaktowe',
        phone: 'Telefon',
        phoneValue: '+48 123 456 789',
        email: 'E-mail',
        emailValue: 'kontakt@golddreams.pl',
        address: 'Adres',
        hours: 'Godziny otwarcia',
        hoursValue: 'Pn-Pt: 9:00 AM - 5:00 PM'
      },
      trust: {
        fast: {
          title: 'Szybka odpowiedź',
          description: 'Odpowiadamy na Twoje zapytanie w ciągu 24 godzin'
        },
        individual: {
          title: 'Indywidualne doradztwo',
          description: 'Osobista konsultacja dotycząca możliwości planu oszczędnościowego'
        },
        competent: {
          title: 'Kompetentne wsparcie',
          description: 'Doświadczeni eksperci odpowiedzą na wszystkie Twoje pytania'
        }
      }
    },
    footer: {
      company: 'Twój zaufany partner w dziedzinie złota i srebra od 2010 roku.',
      navigation: 'Nawigacja',
      services: 'Usługi',
      copyright: 'Wszelkie prawa zastrzeżone.',
      imprint: 'Informacje prawne',
      contact: 'Kontakt',
      privacy: 'Polityka prywatności',
      deliveryPayment: 'Warunki dostawy i płatności'
    },
    privacy: {
      title: 'Polityka prywatności',
      subtitle: 'Twoja prywatność jest dla nas ważna. Tutaj dowiesz się, jak chronimy i przetwarzamy Twoje dane.',
      intro: {
        title: 'Wprowadzenie',
        content1: 'Ochrona Twoich danych osobowych jest dla nas szczególnie ważna. Przetwarzamy Twoje dane wyłącznie na podstawie przepisów prawnych (RODO, TKG 2003).',
        content2: 'W niniejszej polityce prywatności informujemy Cię o najważniejszych aspektach przetwarzania danych w ramach naszej strony internetowej i naszych usług.'
      },
      controller: {
        title: 'Administrator danych',
        email: 'E-mail',
        phone: 'Telefon'
      },
      collection: {
        title: 'Jakie dane zbieramy',
        intro: 'Zbieramy i przetwarzamy następujące dane osobowe:',
        item1: 'Dane kontaktowe (imię i nazwisko, adres e-mail, numer telefonu)',
        item2: 'Dane adresowe do dostaw',
        item3: 'Informacje o płatnościach',
        item4: 'Dane komunikacyjne (zapytania, wiadomości)',
        item5: 'Dane techniczne (adres IP, informacje o przeglądarce, czasy dostępu)'
      },
      purpose: {
        title: 'Cel przetwarzania danych',
        intro: 'Używamy Twoich danych w następujących celach:',
        item1: 'Realizacja zamówień i umów',
        item2: 'Obsługa klienta i odpowiadanie na zapytania',
        item3: 'Wysyłka produktów',
        item4: 'Wypełnianie obowiązków prawnych',
        item5: 'Poprawa naszych usług'
      },
      legal: {
        title: 'Podstawa prawna',
        content1: 'Przetwarzanie Twoich danych odbywa się na podstawie art. 6 ust. 1 RODO:',
        content2: 'a) Zgoda (art. 6 ust. 1 lit. a RODO) – Wyraziłeś nam wyraźną zgodę na przetwarzanie.',
        content3: 'b) Wykonanie umowy (art. 6 ust. 1 lit. b RODO) – Przetwarzanie jest niezbędne do wykonania umowy.'
      },
      retention: {
        title: 'Okres przechowywania',
        content1: 'Przechowujemy Twoje dane osobowe tylko tak długo, jak jest to konieczne do realizacji odpowiednich celów lub obowiązujących ustawowych okresów przechowywania.',
        content2: 'Po upływie tych okresów dane są routynowo usuwane, o ile nie istnieją ustawowe obowiązki przechowywania.'
      },
      rights: {
        title: 'Twoje prawa',
        intro: 'Masz następujące prawa dotyczące swoich danych osobowych:',
        access: 'Prawo dostępu',
        accessDesc: 'Masz prawo uzyskać informacje o swoich przechowywanych danych.',
        rectification: 'Prawo do sprostowania',
        rectificationDesc: 'Możesz żądać poprawienia nieprawidłowych danych.',
        erasure: 'Prawo do usunięcia',
        erasureDesc: 'Możesz żądać usunięcia swoich danych, o ile nie istnieją ustawowe obowiązki przechowywania.',
        restriction: 'Ograniczenie przetwarzania',
        restrictionDesc: 'Możesz żądać ograniczenia przetwarzania swoich danych.',
        portability: 'Przenoszenie danych',
        portabilityDesc: 'Masz prawo otrzymać swoje dane w ustrukturyzowanym formacie.',
        objection: 'Prawo sprzeciwu',
        objectionDesc: 'Możesz sprzeciwić się przetwarzaniu swoich danych.'
      },
      security: {
        title: 'Bezpieczeństwo danych',
        content1: 'Stosujemy odpowiednie techniczne i organizacyjne środki bezpieczeństwa, aby chronić Twoje dane przed przypadkową lub celową manipulacją, utratą, zniszczeniem lub dostępem osób nieuprawnionych.',
        content2: 'Nasze środki bezpieczeństwa są stale ulepszane zgodnie z rozwojem technologicznym.'
      },
      cookies: {
        title: 'Pliki cookie',
        content1: 'Nasza strona internetowa używa plików cookie w celu poprawy użyteczności. Pliki cookie to małe pliki tekstowe przechowywane na Twoim urządzeniu.',
        content2: 'Możesz skonfigurować swoją przeglądarkę tak, aby informowała Cię o ustawianiu plików cookie i zezwalała na pliki cookie tylko w poszczególnych przypadkach lub ogólnie wykluczała akceptację plików cookie.'
      },
      contact: {
        title: 'Kontakt',
        content: 'W przypadku pytań dotyczących ochrony danych możesz skontaktować się z nami w dowolnym momencie:'
      },
      lastUpdated: 'Ostatnia aktualizacja'
    },
    deliveryAndPayment: {
      title: 'Warunki dostawy i płatności',
      section1: {
        title: '1. Zakres obowiązywania',
        content: 'Niniejsze warunki dostawy i płatności obowiązują dla wszystkich zamówień metali szlachetnych (złota i srebra) w GOLD DREAMS. Składając zamówienie, uznają Państwo te warunki za wiążące.'
      },
      section2: {
        title: '2. Zamówienie i zawarcie umowy',
        content1: 'Zamówienia można składać telefonicznie pod numerem +49 (0) 6359 86762 / +49 (0) 172 297 30 22, e-mailem na info@golddreams.eu lub za pomocą naszego formularza kontaktowego.',
        content2: 'Po otrzymaniu zamówienia otrzymają Państwo potwierdzenie zamówienia e-mailem. Umowa zostaje zawarta z chwilą wysłania tego potwierdzenia.',
        content3: 'Podane ceny opierają się na aktualnej cenie rynkowej w momencie zamówienia i nie zawierają ustawowego podatku VAT.'
      },
      section3: {
        title: '3. Ceny',
        content: 'Wszystkie ceny są aktualizowane codziennie i opierają się na aktualnej cenie złota lub srebra. Ceny obowiązujące w momencie zamówienia są wiążące. Ceny podane są w euro i zawierają ustawowy podatek VAT.'
      },
      section4: {
        title: '4. Warunki płatności',
        content1: 'Akceptujemy następujące metody płatności:',
        item1: 'Przelew bankowy (przedpłata)',
        item2: 'Płatność gotówką przy odbiorze (po uzgodnieniu)',
        content2: 'Dostawa następuje dopiero po otrzymaniu pełnej płatności na nasze konto.'
      },
      section5: {
        title: '5. Dostawa i wysyłka',
        content1: 'Dostawa odbywa się w sposób ubezpieczony i dyskretnie zapakowany na podany przez Państwa adres dostawy. Czas dostawy wynosi zazwyczaj 3-5 dni roboczych po otrzymaniu płatności.',
        content2: 'Koszty wysyłki są wliczone w cenę produktu. W przypadku większych zamówień lub planów oszczędnościowych wysyłka jest bezpłatna.'
      },
      section6: {
        title: '6. Gwarancja odkupu',
        content1: 'Gwarantujemy odkup wszystkich metali szlachetnych zakupionych u nas po naszych aktualnych cenach dziennych.',
        content2: 'Skontaktuj się z nami, aby otrzymać niezobowiązującą ofertę odkupu.'
      },
      section7: {
        title: '7. Odpowiedzialność i gwarancja',
        content: 'Wszystkie produkty są certyfikowane przez LBMA i dostarczane z certyfikatem autentyczności. Ponosimy odpowiedzialność za wady materiałowe i produkcyjne zgodnie z przepisami prawnymi. Reklamacje należy zgłaszać na piśmie niezwłocznie po otrzymaniu towaru.'
      }
    },
    imprint: {
      title: 'Informacje prawne',
      section1: {
        title: 'Informacje zgodnie z § 5 TMG',
        company: 'GOLD DREAMS',
        legalForm: 'Jednoosobowa działalność gospodarcza',
        address: 'Hauptstraße 123',
        city: '67346 Speyer',
        country: 'Niemcy'
      },
      section2: {
        title: 'Kontakt',
        phone: 'Telefon',
        phoneValue: '+49 (0) 6359 86762',
        mobile: 'Telefon komórkowy',
        mobileValue: '+49 (0) 172 297 30 22',
        email: 'E-mail',
        emailValue: 'info@golddreams.eu'
      },
      section3: {
        title: 'Numer identyfikacji podatkowej VAT',
        content: 'Numer identyfikacji podatkowej VAT zgodnie z § 27a ustawy o podatku od wartości dodanej:',
        vatId: ''
      },
      section4: {
        title: 'Tytuł zawodowy',
        profession: 'Tytuł zawodowy',
        professionValue: 'Handlarz metalami szlachetnymi',
        country: 'Nadany w',
        countryValue: 'Niemcy'
      },
      section5: {
        title: 'Rozstrzyganie sporów UE',
        content: 'Komisja Europejska udostępnia platformę do internetowego rozstrzygania sporów (OS):',
        link: 'https://ec.europa.eu/consumers/odr',
        email: 'Nasz adres e-mail znajduje się powyżej w informacjach prawnych.'
      },
      section6: {
        title: 'Rozstrzyganie sporów konsumenckich',
        content: 'Nie jesteśmy gotowi ani zobowiązani do uczestnictwa w postępowaniach rozstrzygania sporów przed organem rozjemczym ds. konsumentów.'
      }
    }
  },
  ru: {
    header: {
      home: 'Главная',
      aboutUs: 'О нас',
      whyGoldSilver: 'Почему золото и серебро',
      products: 'Продукты',
      priceList: 'Прайс-лист',
      contact: 'Контакт'
    },
    common: {
      contactUs: 'Связаться с нами',
      viewProducts: 'Посмотреть продукты'
    },
    cookie: {
      message: 'Мы используем файлы cookie для улучшения вашего опыта на нашем сайте. Используя наш сайт, вы соглашаетесь с нашей',
      privacyPolicy: 'Политикой конфиденциальности',
      accept: 'Принять',
      decline: 'Отклонить'
    },
    home: {
      hero: {
        headline: 'Воплотите свои мечты о завтрашнем дне, купив золото сегодня',
        subheadline: 'Защитите своё состояние физическим золотом и серебром – прозрачно, сертифицированно и конфиденциально',
        quote: '»Важно не предсказывать будущее, а быть к нему готовым.«',
        quoteAuthor: 'Перикл (500–429 до н.э.)'
      },
      trust: {
        title: 'Почему GOLD DREAMS?',
        transparency: {
          title: 'Прозрачность',
          description: 'Честные цены без скрытых расходов. Вы всегда видите актуальную цену.'
        },
        quality: {
          title: 'Сертифицированное качество',
          description: 'Все продукты сертифицированы LBMA и соответствуют высочайшим стандартам качества. Произведено в Германии с чистотой 999.9/1000.'
        },
        security: {
          title: 'Безопасно и конфиденциально',
          description: 'Застрахованная доставка и дискретная упаковка. Ваша конфиденциальность и безопасность – наш главный приоритет.'
        },
        consultation: {
          title: 'Персональная консультация',
          description: 'Наша команда экспертов индивидуально проконсультирует вас по вашей стратегии и поддержит на пути к финансовой безопасности.'
        }
      },
      process: {
        title: 'Как это работает',
        subtitle: 'Ваш путь к финансовой безопасности в 3 простых шага',
        step1: {
          title: 'Консультация и выбор',
          description: 'Запишитесь на бесплатную консультацию. Вместе мы найдём правильную стратегию для ваших целей и выберем оптимальные продукты.'
        },
        step2: {
          title: 'Связь с нами',
          description: 'Свяжитесь с нами удобным способом – по телефону, электронной почте или сообщением. Мы гарантируем актуальные цены и прозрачное оформление без скрытых комиссий.'
        },
        step3: {
          title: 'Доставка',
          description: 'Ваши драгоценные металлы будут застрахованы и дискретно упакованы, а затем доставлены прямо к вам домой.'
        }
      },
      products: {
        title: 'Наши возможности накопления',
        subtitle: 'Выберите подходящий вариант для вашей стратегии',
        popular: 'Популярно',
        savingsPlan: {
          badge: 'План накопления',
          title: 'Ежемесячные планы накопления',
          description: 'Систематически накапливайте состояние с гибкими ежемесячными взносами в золото и серебро.',
          priceLabel: 'От',
          priceAmount: '50€/месяц',
          feature1: 'Гибкое накопление от 50€ в месяц',
          feature2: 'Автоматическая покупка по текущей цене',
          feature3: 'Можно изменить или отменить в любое время',
          feature4: 'Бесплатное управление депозитом',
          feature5: 'Персональная консультация включена',
          cta: 'Связаться сейчас'
        },
        oneTime: {
          badge: 'Единовременный заказ',
          title: 'Единовременные заказы',
          description: 'Целенаправленно инвестируйте в золотые слитки, серебряные слитки или монеты. Большой выбор продуктов, сертифицированных LBMA.',
          priceLabel: 'От',
          priceAmount: '500€',
          feature1: 'Продукты, сертифицированные LBMA',
          feature2: 'Произведено в Германии',
          feature3: 'Застрахованная доставка',
          feature4: 'Гарантия обратного выкупа',
          feature5: 'Персональная консультация включена',
          cta: 'Связаться сейчас'
        }
      },
      cta: {
        title: 'Готовы инвестировать в драгоценные металлы?',
        description: 'Начните свой путь к финансовой безопасности уже сегодня. Наши эксперты готовы помочь вам.',
        button: 'Получить бесплатную консультацию'
      }
    },
    products: {
      title: 'Наши продукты',
      subtitle: 'Высококачественные драгоценные металлы для ваших инвестиций',
      savingsPlan: {
        title: 'Планы накопления золота и серебра',
        description: 'Систематически накапливайте состояние с гибкими ежемесячными взносами в золото и серебро.',
        priceFrom: 'От 50€/месяц',
        feature1: 'Гибкие ежемесячные взносы',
        feature2: 'Эффект усреднения стоимости',
        feature3: 'Можно отменить в любое время',
        feature4: 'Бесплатное управление депозитом',
        feature5: 'Персональная консультация включена',
        cta: 'Связаться сейчас'
      },
      oneTime: {
        title: 'Единовременные заказы драгоценных металлов',
        description: 'Целенаправленно инвестируйте в золотые слитки, серебряные слитки или монеты. Большой выбор продуктов, сертифицированных LBMA.',
        priceFrom: 'От 500€',
        feature1: 'Продукты, сертифицированные LBMA',
        feature2: 'Произведено в Германии',
        feature3: 'Застрахованная доставка',
        feature4: 'Гарантия обратного выкупа',
        feature5: 'Персональная консультация включена',
        cta: 'Связаться сейчас'
      },
      certification: {
        title: 'Сертификация LBMA',
        description: 'Все наши продукты соответствуют стандарту LBMA Good Delivery – всемирно признанному знаку качества для драгоценных металлов.'
      },
      buyback: {
        title: 'Гарантия обратного выкупа',
        description: 'Мы гарантируем обратный выкуп приобретённых у нас драгоценных металлов по нашим дневным ценам. Ваши инвестиции остаются ликвидными и доступными в любое время.'
      },
      contactNote: {
        title: 'Интересуют наши продукты?',
        description: 'Свяжитесь с нами по телефону, электронной почте или через контактную форму, чтобы сделать заказ или получить персональную консультацию.',
        phone: 'Телефон',
        email: 'Эл. почта',
        form: 'Контактная форма'
      },
      pageTitle: 'Наши продукты',
      metalHighlights: {
        gold: {
          metal: 'Золото',
          purity: '999.9/1000 (99,9% чистого золота)',
          imageAlt: 'Крупный план небольших золотых слитков весом до 200 г'
        },
        silver: {
          metal: 'Серебро',
          purity: '999.9/1000 (99,9% чистого серебра)',
          imageAlt: 'Серебряные слитки, заполняющие всё изображение'
        }
      },
      availableWeights: 'Доступные веса:',
      purityLabel: 'Чистота:',
      priceList: 'Прайс-лист',
      certificationSection: {
        title: 'Качество и сертификация'
      },
      certifications: {
        madeInGermany: {
          title: 'Сделано в Германии',
          description: 'Все продукты производятся в Германии по высочайшим стандартам качества'
        },
        lbmaCertified: {
          title: 'Сертифицировано LBMA',
          description: 'Соответствует стандарту LBMA Good Delivery для международного признания'
        },
        authenticityCertificate: {
          title: 'Сертификат подлинности',
          description: 'Каждый продукт поставляется с официальным сертификатом подлинности'
        }
      },
      infoBox: {
        title: 'Гарантия обратного выкупа',
        description: 'Мы гарантируем обратный выкуп приобретённых у нас драгоценных металлов по нашим дневным ценам. Ваши инвестиции остаются ликвидными и доступными в любое время.'
      }
    },
    priceList: {
      title: 'Актуальный прайс-лист',
      subtitle: 'Прозрачные цены на золото и серебро – обновляются ежедневно',
      table: {
        product: 'Продукт',
        weight: 'Вес',
        purity: 'Чистота',
        ankauf: 'Скупка (нетто)',
        verkaufNetto: 'Продажа (нетто)',
        verkaufBrutto: 'Продажа (брутто)',
        contact: 'Контакт'
      },
      goldBars: 'Золотые слитки',
      silverBars: 'Серебряные слитки',
      lastUpdated: 'Последнее обновление',
      contactNote: 'Для оформления заказа свяжитесь с нами по телефону +49 (0) 6359 86762 / +49 (0) 172 297 30 22, по электронной почте info@golddreams.eu или через контактную форму.',
      features: {
        quality: {
          title: 'Качество, сертифицированное LBMA',
          description: 'Все наши продукты соответствуют стандарту LBMA Good Delivery и производятся в Германии.'
        },
        daily: {
          title: 'Ежедневно обновляемые цены',
          description: 'Наши цены обновляются ежедневно. Вы всегда получаете честные и прозрачные условия.'
        },
        buyback: {
          title: 'Гарантия обратного выкупа',
          description: 'Мы выкупаем ваши драгоценные металлы в любое время по нашим дневным ценам.'
        }
      },
      cta: {
        title: 'Готовы инвестировать?',
        description: 'Свяжитесь с нами для получения актуальных цен и персональной консультации.',
        button1: 'Связаться сейчас',
        button2: 'Посмотреть продукты'
      }
    },
    whyGoldSilver: {
      title: 'Почему золото и серебро?',
      intro: {
        description: 'Золото и серебро на протяжении тысячелетий являются надёжными средствами сохранения ценности и защищают от инфляции и экономических кризисов.',
        highlight: 'Любая земная власть проходит – ценность золота и серебра остаётся.'
      },
      example: {
        title: 'Пример плана накопления',
        trendRising: 'Тренд растущий',
        investmentTitle: 'Инвестиции в золото с 1999 года',
        investmentPeriod: 'на протяжении 26 лет всего по 100 € в месяц',
        goldAmount: 'Сегодня у вас дома было бы 1,5 кг золота.',
        totalInvestment: 'Общая инвестиция',
        totalInvestmentValue: 'ок. 30.000 €',
        currentValue: 'Текущая стоимость',
        currentValueAmount: 'ок. 215.000 €',
        asOf: 'По состоянию на: январь 2025. Историческая доходность не является гарантией будущих результатов.'
      },
      historical: {
        title: 'Историческая динамика цен',
        subtitle: 'Сравнение цен на золото с 1999 по 2025 год',
        pricePerKg: 'Цена за кг (€)',
        gold: 'Золото',
        silver: 'Серебро'
      },
      calculator: {
        title: 'Калькулятор накопления',
        subtitle: 'Рассчитайте свой потенциальный доход',
        investment: 'Сумма инвестиции',
        period: 'Срок инвестирования',
        years: 'лет',
        calculate: 'Рассчитать доход',
        result: 'Расчётная стоимость через',
        disclaimer: 'Это оценка на основе исторических данных. Фактическая доходность может отличаться.'
      },
      benefits: {
        title: 'Преимущества золота и серебра',
        benefit1: {
          title: 'Защита от инфляции',
          description: 'Золото и серебро сохраняют свою ценность даже при росте инфляции и защищают ваше состояние.'
        },
        benefit2: {
          title: 'Защита в кризис',
          description: 'Драгоценные металлы независимы от банков и валют – надёжная гавань в неспокойные времена.'
        },
        benefit3: {
          title: 'Диверсификация портфеля',
          description: 'Драгоценные металлы снижают риск вашего портфеля благодаря низкой корреляции с другими классами активов.'
        },
        benefit4: {
          title: 'Долгосрочное сохранение ценности',
          description: 'Золото и серебро сохраняли свою ценность на протяжении веков и являются надёжной инвестицией.'
        },
        benefit5: {
          title: 'Физическое владение',
          description: 'Вы владеете реальными, осязаемыми ценностями – не цифровыми обещаниями и не бумажными деньгами.'
        },
        benefit6: {
          title: 'Признано во всём мире',
          description: 'Золото и серебро принимаются по всему миру в качестве средства платежа и инвестиции.'
        },
        benefit7: {
          title: 'Налоговые преимущества',
          description: 'Физическое золото освобождается от налога после одного года владения – привлекательная инвестиция для долгосрочных инвесторов.'
        }
      },
      cta: {
        title: 'Готовы инвестировать в драгоценные металлы?',
        description: 'Свяжитесь с нами для получения актуальных цен и персональной консультации.',
        button: 'Записаться на консультацию',
        button1: 'Записаться на консультацию',
        button2: 'Посмотреть продукты'
      }
    },
    news: {
      title: 'Новости и аналитика',
      subtitle: 'Будьте в курсе рынков драгоценных металлов и инвестиционных стратегий',
      readTime: 'мин. чтения'
    },
    aboutUs: {
      title: 'О нас',
      subtitle: 'Ваш надёжный партнёр в сфере защиты активов драгоценными металлами',
      company: {
        title: 'О GOLD DREAMS',
        description: 'Мы являемся компанией финансового сектора, специализирующейся на продаже инвестиционного золота. Наше предложение ориентировано на клиентов, ищущих надёжные и проверенные способы сохранения капитала и частного пенсионного обеспечения.\n\nМы придаём большое значение прозрачности, надёжности и индивидуальному обслуживанию каждого клиента. Мы помогаем в выборе подходящих инвестиционных продуктов, соответствующих текущей рыночной ситуации и личным финансовым целям.\n\nМы работаем исключительно с авторитетными поставщиками и предлагаем сертифицированное золото высочайшего качества. Безопасность сделок, чёткие условия и абсолютная конфиденциальность являются для нас наивысшим приоритетом.\n\nБлагодаря нашему опыту и постоянному анализу финансовых рынков мы сопровождаем наших клиентов в осознанных и взвешенных инвестиционных решениях. Наша цель – выстраивать долгосрочные деловые отношения, основанные на доверии и профессионализме.\n\nМы приглашаем вас связаться с нами – мы ответим на ваши вопросы и поможем найти решения, адаптированные к вашим индивидуальным потребностям.'
      },
      values: {
        title: 'Наши ценности',
        trust: {
          title: 'Доверие и прозрачность',
          description: 'Мы верим в открытое общение и честные цены. Никаких скрытых расходов, никаких сюрпризов.'
        },
        quality: {
          title: 'Качество и сертификация',
          description: 'Все наши продукты сертифицированы LBMA и соответствуют высочайшим международным стандартам.'
        },
        service: {
          title: 'Сервис и консультации',
          description: 'Наши опытные эксперты готовы помочь вам найти наилучшую стратегию для ваших нужд.'
        }
      },
      faq: {
        title: 'Часто задаваемые вопросы',
        q1: {
          question: 'Почему я должен инвестировать в золото и серебро?',
          answer: 'Золото и серебро – проверенные средства сохранения ценности, защищающие от инфляции и экономических кризисов. Они обеспечивают диверсификацию портфеля и долгосрочное сохранение стоимости.'
        },
        q2: {
          question: 'Что означает сертификация LBMA?',
          answer: 'Стандарт LBMA (London Bullion Market Association) Good Delivery – это всемирно признанный знак качества для драгоценных металлов. Он гарантирует чистоту, вес и прослеживаемость.'
        },
        q3: {
          question: 'Как работает план накопления?',
          answer: 'С нашим планом накопления вы ежемесячно инвестируете фиксированную сумму в золото и/или серебро. Это позволяет использовать эффект усреднения стоимости и систематически накапливать состояние.'
        },
        q4: {
          question: 'Могу ли я продать свои драгоценные металлы обратно?',
          answer: 'Да, мы предлагаем гарантию обратного выкупа по справедливым дневным ценам. Ваши инвестиции остаются ликвидными и могут быть проданы в любое время.'
        }
      },
      cta: 'Связаться с нами',
      viewProducts: 'Посмотреть наши продукты'
    },
    contact: {
      title: 'Свяжитесь с нами',
      subtitle: 'Есть вопросы о наших продуктах или хотите получить персональную консультацию? Мы здесь для вас.',
      form: {
        title: 'Отправьте нам сообщение',
        name: 'Ваше имя',
        email: 'Ваш e-mail',
        phone: 'Номер телефона (необязательно)',
        subject: 'Тема',
        message: 'Ваше сообщение',
        submit: 'Отправить сообщение',
        sending: 'Отправка...',
        success: 'Спасибо! Мы свяжемся с вами в ближайшее время.',
        error: 'Произошла ошибка. Пожалуйста, попробуйте ещё раз.'
      },
      info: {
        title: 'Контактная информация',
        phone: 'Телефон',
        email: 'Эл. почта',
        address: 'Адрес',
        hours: 'Часы работы',
        hoursValue: 'Пн-Пт: 9:00 - 17:00'
      },
      trust: {
        fast: {
          title: 'Быстрый ответ',
          description: 'Мы отвечаем на ваш запрос в течение 24 часов'
        },
        individual: {
          title: 'Индивидуальная консультация',
          description: 'Персональная консультация по возможностям плана накопления'
        },
        competent: {
          title: 'Компетентная поддержка',
          description: 'Опытные эксперты ответят на все ваши вопросы'
        }
      }
    },
    footer: {
      company: 'Ваш надёжный партнёр в сфере золота и серебра с 2010 года.',
      navigation: 'Навигация',
      services: 'Услуги',
      copyright: 'Все права защищены.',
      imprint: 'Выходные данные',
      contact: 'Контакт',
      privacy: 'Политика конфиденциальности',
      deliveryPayment: 'Условия доставки и оплаты'
    },
    privacy: {
      title: 'Политика конфиденциальности',
      subtitle: 'Ваша конфиденциальность важна для нас. Здесь вы узнаете, как мы защищаем и обрабатываем ваши данные.',
      intro: {
        title: 'Введение',
        content1: 'Защита ваших персональных данных особенно важна для нас. Мы обрабатываем ваши данные исключительно на основании законодательных норм (GDPR, TKG 2003).',
        content2: 'В настоящей политике конфиденциальности мы информируем вас о важнейших аспектах обработки данных в рамках нашего сайта и наших услуг.'
      },
      controller: {
        title: 'Ответственный за обработку данных',
        email: 'Эл. почта',
        phone: 'Телефон'
      },
      collection: {
        title: 'Какие данные мы собираем',
        intro: 'Мы собираем и обрабатываем следующие персональные данные:',
        item1: 'Контактные данные (имя, адрес электронной почты, номер телефона)',
        item2: 'Адресные данные для доставки',
        item3: 'Платёжная информация',
        item4: 'Данные коммуникации (запросы, сообщения)',
        item5: 'Технические данные (IP-адрес, информация о браузере, время доступа)'
      },
      purpose: {
        title: 'Цель обработки данных',
        intro: 'Мы используем ваши данные в следующих целях:',
        item1: 'Обработка заказов и договоров',
        item2: 'Обслуживание клиентов и ответы на запросы',
        item3: 'Доставка продуктов',
        item4: 'Выполнение законодательных обязательств',
        item5: 'Улучшение наших услуг'
      },
      legal: {
        title: 'Правовое основание',
        content1: 'Обработка ваших данных осуществляется на основании ст. 6 п. 1 GDPR:',
        content2: 'а) Согласие (ст. 6 п. 1 лит. а GDPR) – вы дали нам явное согласие на обработку.',
        content3: 'б) Исполнение договора (ст. 6 п. 1 лит. б GDPR) – обработка необходима для исполнения договора.'
      },
      retention: {
        title: 'Срок хранения',
        content1: 'Мы храним ваши персональные данные только до тех пор, пока это необходимо для выполнения соответствующих целей или соблюдения законодательных сроков хранения.',
        content2: 'По истечении этих сроков данные планово удаляются, если дальнейшая обработка не требуется.'
      },
      rights: {
        title: 'Ваши права',
        intro: 'Вы имеете следующие права в отношении ваших персональных данных:',
        access: 'Право на доступ',
        accessDesc: 'Вы имеете право получить информацию о хранящихся данных.',
        rectification: 'Право на исправление',
        rectificationDesc: 'Вы можете потребовать исправления неточных данных.',
        erasure: 'Право на удаление',
        erasureDesc: 'Вы можете потребовать удаления ваших данных, если нет законодательных обязательств по хранению.',
        restriction: 'Ограничение обработки',
        restrictionDesc: 'Вы можете потребовать ограничения обработки ваших данных.',
        portability: 'Переносимость данных',
        portabilityDesc: 'Вы имеете право получить свои данные в структурированном формате.',
        objection: 'Право на возражение',
        objectionDesc: 'Вы можете возразить против обработки ваших данных.'
      },
      security: {
        title: 'Безопасность данных',
        content1: 'Мы применяем надлежащие технические и организационные меры безопасности для защиты ваших данных от случайного или преднамеренного изменения, потери, уничтожения или доступа неуполномоченных лиц.',
        content2: 'Наши меры безопасности постоянно совершенствуются в соответствии с технологическим развитием.'
      },
      cookies: {
        title: 'Файлы cookie',
        content1: 'Наш сайт использует файлы cookie для улучшения удобства использования. Файлы cookie – это небольшие текстовые файлы, хранящиеся на вашем устройстве.',
        content2: 'Вы можете настроить браузер так, чтобы он уведомлял вас об установке файлов cookie и разрешал их только в отдельных случаях или полностью запрещал их принятие.'
      },
      contact: {
        title: 'Контакт',
        content: 'По вопросам защиты данных вы можете обратиться к нам в любое время:'
      },
      lastUpdated: 'Последнее обновление'
    },
    deliveryAndPayment: {
      title: 'Условия доставки и оплаты',
      section1: {
        title: '1. Область применения',
        content: 'Настоящие условия доставки и оплаты распространяются на все заказы драгоценных металлов (золота и серебра) в GOLD DREAMS. Оформляя заказ, вы признаёте эти условия обязательными.'
      },
      section2: {
        title: '2. Заказ и заключение договора',
        content1: 'Заказы можно оформить по телефону +49 (0) 6359 86762 / +49 (0) 172 297 30 22, по электронной почте info@golddreams.eu или через нашу контактную форму.',
        content2: 'После получения вашего заказа вы получите подтверждение заказа по электронной почте. Договор вступает в силу с момента отправки этого подтверждения.',
        content3: 'Указанные цены основаны на текущей рыночной цене на момент заказа и указаны без учёта НДС.'
      },
      section3: {
        title: '3. Цены',
        content: 'Все цены обновляются ежедневно и основаны на текущей цене золота или серебра. Цены, действующие на момент заказа, являются обязательными. Цены указаны в евро и включают НДС.'
      },
      section4: {
        title: '4. Условия оплаты',
        content1: 'Мы принимаем следующие способы оплаты:',
        item1: 'Банковский перевод (предоплата)',
        item2: 'Наличная оплата при самовывозе (по договорённости)',
        content2: 'Доставка осуществляется только после поступления полной оплаты на наш счёт.'
      },
      section5: {
        title: '5. Доставка и отправка',
        content1: 'Доставка осуществляется в застрахованном и дискретно упакованном виде по указанному вами адресу доставки. Срок доставки обычно составляет 3-5 рабочих дней после получения оплаты.',
        content2: 'Стоимость доставки включена в цену продукта. При крупных заказах или планах накопления доставка бесплатна.'
      },
      section6: {
        title: '6. Гарантия обратного выкупа',
        content1: 'Мы гарантируем обратный выкуп всех приобретённых у нас драгоценных металлов по нашим текущим дневным ценам.',
        content2: 'Свяжитесь с нами для получения необязывающего предложения об обратном выкупе.'
      },
      section7: {
        title: '7. Ответственность и гарантия',
        content: 'Все продукты сертифицированы LBMA и поставляются с сертификатом подлинности. Мы несём ответственность за дефекты материала и производства в соответствии с законодательными нормами. Претензии должны быть поданы в письменной форме незамедлительно после получения товара.'
      }
    },
    imprint: {
      title: 'Выходные данные',
      section1: {
        title: 'Сведения согласно § 5 TMG',
        company: 'GOLD DREAMS',
        legalForm: 'Индивидуальный предприниматель',
        address: 'Hauptstraße 123',
        city: '67346 Speyer',
        country: 'Германия'
      },
      section2: {
        title: 'Контакт',
        phone: 'Телефон',
        phoneValue: '+49 (0) 6359 86762',
        mobile: 'Мобильный',
        mobileValue: '+49 (0) 172 297 30 22',
        email: 'Эл. почта',
        emailValue: 'info@golddreams.eu'
      },
      section3: {
        title: 'Идентификационный номер плательщика НДС',
        content: 'Идентификационный номер плательщика НДС согласно § 27a Закона об НДС:',
        vatId: ''
      },
      section4: {
        title: 'Профессиональное звание',
        profession: 'Профессиональное звание',
        professionValue: 'Торговец драгоценными металлами',
        country: 'Присвоено в',
        countryValue: 'Германия'
      },
      section5: {
        title: 'Урегулирование споров в ЕС',
        content: 'Европейская комиссия предоставляет платформу для онлайн-урегулирования споров (OS):',
        link: 'https://ec.europa.eu/consumers/odr',
        email: 'Наш адрес электронной почты указан выше в выходных данных.'
      },
      section6: {
        title: 'Урегулирование потребительских споров',
        content: 'Мы не готовы и не обязаны участвовать в процедурах урегулирования споров перед органом по урегулированию потребительских споров.'
      }
    }
  },
  en: {
    header: {
      home: 'Home',
      aboutUs: 'About Us',
      whyGoldSilver: 'Why Gold & Silver',
      products: 'Products',
      priceList: 'Price List',
      contact: 'Contact'
    },
    common: {
      contactUs: 'Contact Us',
      viewProducts: 'View Products'
    },
    cookie: {
      message: 'We use cookies to improve your experience on our website. By using our website, you agree to our',
      privacyPolicy: 'Privacy Policy',
      accept: 'Accept',
      decline: 'Decline'
    },
    home: {
      hero: {
        headline: 'Realise your dreams of tomorrow with your gold purchase today',
        subheadline: 'Secure your wealth with physical gold and silver – transparent, certified and discreet',
        quote: '»It is not about predicting the future, but about being prepared for it.«',
        quoteAuthor: 'Pericles (500–429 BC)'
      },
      trust: {
        title: 'Why GOLD DREAMS?',
        transparency: {
          title: 'Transparency',
          description: 'Fair prices with no hidden costs. You can always see the current price.'
        },
        quality: {
          title: 'Certified Quality',
          description: 'All products are LBMA-certified and meet the highest quality standards. Made in Germany with a purity of 999.9/1000.'
        },
        security: {
          title: 'Safe & Discreet',
          description: 'Insured shipping and discreet packaging. Your privacy and security are our top priority.'
        },
        consultation: {
          title: 'Personal Consultation',
          description: 'Our team of experts will advise you individually on your strategy and support you on your path to financial security.'
        }
      },
      process: {
        title: 'How It Works',
        subtitle: 'Your path to financial security in 3 simple steps',
        step1: {
          title: 'Consultation & Selection',
          description: 'Schedule a free consultation. Together we will find the right strategy for your goals and select the optimal products.'
        },
        step2: {
          title: 'Get in Touch',
          description: 'Contact us conveniently by phone, email or message. We guarantee current prices and transparent processing with no hidden fees.'
        },
        step3: {
          title: 'Delivery',
          description: 'Your precious metals will be insured and discreetly packaged and delivered directly to your home.'
        }
      },
      products: {
        title: 'Our Savings Plan Options',
        subtitle: 'Choose the right option for your strategy',
        popular: 'Popular',
        savingsPlan: {
          badge: 'Savings Plan',
          title: 'Monthly Savings Plans',
          description: 'Systematically build wealth with flexible monthly amounts in gold and silver.',
          priceLabel: 'From',
          priceAmount: '€50/month',
          feature1: 'Flexible savings from €50 per month',
          feature2: 'Automatic purchase at the current price',
          feature3: 'Adjustable or cancellable at any time',
          feature4: 'Premium insured shipping',
          feature5: 'Personal consultation included',
          cta: 'Contact us now'
        },
        oneTime: {
          badge: 'One-Time Order',
          title: 'One-Time Orders',
          description: 'Invest specifically in gold bars, silver bars or coins. Large selection of LBMA-certified products.',
          priceLabel: 'From',
          priceAmount: '€500',
          feature1: 'LBMA-certified products',
          feature2: 'Made in Germany',
          feature3: 'Insured shipping',
          feature4: 'Premium insured shipping',
          feature5: 'Personal consultation included',
          cta: 'Contact us now'
        }
      },
      cta: {
        title: 'Ready to invest in precious metals?',
        description: 'Start your journey to financial security today. Our experts are here for you.',
        button: 'Get a free consultation'
      }
    },
    products: {
      title: 'Our Products',
      subtitle: 'High-quality precious metals for your investment',
      savingsPlan: {
        title: 'Gold & Silver Savings Plans',
        description: 'Systematically build wealth with flexible monthly amounts in gold and silver.',
        priceFrom: 'From €50/month',
        feature1: 'Flexible monthly instalments',
        feature2: 'Cost-average effect',
        feature3: 'Cancellable at any time',
        feature4: 'Free portfolio management',
        feature5: 'Personal consultation included',
        cta: 'Contact us now'
      },
      oneTime: {
        title: 'One-Time Precious Metal Orders',
        description: 'Invest specifically in gold bars, silver bars or coins. Large selection of LBMA-certified products.',
        priceFrom: 'From €500',
        feature1: 'LBMA-certified products',
        feature2: 'Made in Germany',
        feature3: 'Insured shipping',
        feature4: 'Buyback guarantee',
        feature5: 'Personal consultation included',
        cta: 'Contact us now'
      },
      certification: {
        title: 'LBMA Certification',
        description: 'All our products meet the LBMA Good Delivery Standard – the globally recognised quality seal for precious metals.'
      },
      buyback: {
        title: 'Buyback Guarantee',
        description: 'We guarantee the buyback of precious metals purchased from us at our daily prices. Your investment remains liquid and flexibly available at all times.'
      },
      contactNote: {
        title: 'Interested in our products?',
        description: 'Contact us by phone, email or via the contact form to place an order or receive a personal consultation.',
        phone: 'Phone',
        email: 'Email',
        form: 'Contact Form'
      },
      pageTitle: 'Our Products',
      metalHighlights: {
        gold: {
          metal: 'Gold',
          purity: '999.9/1000 (99.9% pure gold)',
          imageAlt: 'Close-up of small gold bars up to a maximum of 200g'
        },
        silver: {
          metal: 'Silver',
          purity: '999.9/1000 (99.9% pure silver)',
          imageAlt: 'Silver bars filling the entire image'
        }
      },
      availableWeights: 'Available weights:',
      purityLabel: 'Purity:',
      priceList: 'Price List',
      certificationSection: {
        title: 'Quality and Certification'
      },
      certifications: {
        madeInGermany: {
          title: 'Made in Germany',
          description: 'All products are manufactured in Germany to the highest quality standards'
        },
        lbmaCertified: {
          title: 'LBMA Certified',
          description: 'Meets the LBMA Good Delivery Standard for international recognition'
        },
        authenticityCertificate: {
          title: 'Certificate of Authenticity',
          description: 'Every product is delivered with an official certificate of authenticity'
        }
      },
      infoBox: {
        title: 'Buyback Guarantee',
        description: 'We guarantee the buyback of precious metals purchased from us at our daily prices. Your investment remains liquid and flexibly available at all times.'
      }
    },
    priceList: {
      title: 'Current Price List',
      subtitle: 'Transparent prices for gold and silver – updated daily',
      table: {
        product: 'Product',
        weight: 'Weight',
        purity: 'Purity',
        ankauf: 'Purchase (Net)',
        verkaufNetto: 'Sale (Net)',
        verkaufBrutto: 'Sale (Gross)',
        contact: 'Contact'
      },
      goldBars: 'Gold Bars',
      silverBars: 'Silver Bars',
      lastUpdated: 'Last updated',
      contactNote: 'To place an order, please contact us by phone at +49 (0) 6359 86762 / +49 (0) 172 297 30 22, by email at info@golddreams.eu or via the contact form.',
      features: {
        quality: {
          title: 'LBMA-Certified Quality',
          description: 'All our products meet the LBMA Good Delivery Standard and are manufactured in Germany.'
        },
        daily: {
          title: 'Daily Updated Prices',
          description: 'Our prices are adjusted daily. You always receive fair and transparent conditions.'
        },
        buyback: {
          title: 'Buyback Guarantee',
          description: 'We buy back your precious metals at any time at our daily prices.'
        }
      },
      cta: {
        title: 'Ready to invest?',
        description: 'Contact us for current prices and a personal consultation.',
        button1: 'Contact us now',
        button2: 'View products'
      }
    },
    whyGoldSilver: {
      title: 'Why Gold & Silver?',
      intro: {
        description: 'Gold and silver have been proven stores of value for thousands of years and offer protection against inflation and economic crises.',
        highlight: 'Every earthly power passes – the value of gold and silver endures.'
      },
      example: {
        title: 'Example of a Savings Plan',
        trendRising: 'Trend rising',
        investmentTitle: 'Investment in gold since 1999',
        investmentPeriod: 'over a period of 26 years with just €100 per month',
        goldAmount: 'Today you would have 1.5 kg of gold at home.',
        totalInvestment: 'Total investment',
        totalInvestmentValue: 'approx. €30,000',
        currentValue: 'Current value',
        currentValueAmount: 'approx. €215,000',
        asOf: 'As of: January 2025. Historical performance is no guarantee of future returns.'
      },
      historical: {
        title: 'Historical Price Development',
        subtitle: 'Comparison of gold prices from 1999 to 2025',
        pricePerKg: 'Price per kg (€)',
        gold: 'Gold',
        silver: 'Silver'
      },
      calculator: {
        title: 'Savings Plan Calculator',
        subtitle: 'Calculate your potential return',
        investment: 'Investment amount',
        period: 'Investment period',
        years: 'years',
        calculate: 'Calculate return',
        result: 'Estimated value after',
        disclaimer: 'This is an estimate based on historical data. Actual returns may vary.'
      },
      benefits: {
        title: 'Benefits of Gold & Silver',
        benefit1: {
          title: 'Inflation Protection',
          description: 'Gold and silver retain their value even with rising inflation and protect your wealth.'
        },
        benefit2: {
          title: 'Crisis-Proof',
          description: 'Precious metals are independent of banks and currencies – a safe haven in uncertain times.'
        },
        benefit3: {
          title: 'Portfolio Diversification',
          description: 'Precious metals reduce the risk of your portfolio through low correlation with other asset classes.'
        },
        benefit4: {
          title: 'Long-Term Value Preservation',
          description: 'Gold and silver have retained their value over centuries and are a reliable investment.'
        },
        benefit5: {
          title: 'Physical Ownership',
          description: 'You own real, tangible values – not digital promises or paper money.'
        },
        benefit6: {
          title: 'Globally Recognised',
          description: 'Gold and silver are accepted worldwide as a means of payment and investment.'
        },
        benefit7: {
          title: 'Tax Advantages',
          description: 'Physical gold is tax-free after one year of holding – an attractive investment for long-term investors.'
        }
      },
      cta: {
        title: 'Ready to invest in precious metals?',
        description: 'Contact us for current prices and a personal consultation.',
        button: 'Schedule a consultation now',
        button1: 'Schedule a consultation now',
        button2: 'View products'
      }
    },
    news: {
      title: 'News & Insights',
      subtitle: 'Stay informed about precious metal markets and investment strategies',
      readTime: 'min. read'
    },
    aboutUs: {
      title: 'About Us',
      subtitle: 'Your trusted partner for precious metal asset protection',
      company: {
        title: 'About GOLD DREAMS',
        description: 'We are a company from the financial sector specialising in the sale of investment gold. Our offering is aimed at customers looking for safe and proven ways to protect their assets and provide for private retirement.\n\nWe place great importance on transparency, reliability and individual support for each customer. We assist in selecting suitable investment products tailored to the current market situation and personal financial goals.\n\nWe work exclusively with reputable suppliers and offer certified gold of the highest quality. Transaction security, clear terms and absolute confidentiality are our top priorities.\n\nThrough our experience and ongoing analysis of financial markets, we accompany our customers in making conscious and well-considered investment decisions. Our goal is to build long-term business relationships based on trust and professionalism.\n\nWe invite you to get in touch – we will answer your questions and help you find solutions tailored to your individual needs.'
      },
      values: {
        title: 'Our Values',
        trust: {
          title: 'Trust and Transparency',
          description: 'We believe in open communication and fair prices. No hidden costs, no surprises.'
        },
        quality: {
          title: 'Quality and Certification',
          description: 'All our products are LBMA-certified and meet the highest international standards.'
        },
        service: {
          title: 'Service and Consultation',
          description: 'Our experienced experts are here to help you find the best strategy for your needs.'
        }
      },
      faq: {
        title: 'Frequently Asked Questions',
        q1: {
          question: 'Why should I invest in gold and silver?',
          answer: 'Gold and silver are proven stores of value that protect against inflation and economic crises. They offer portfolio diversification and long-term value preservation.'
        },
        q2: {
          question: 'What does LBMA certification mean?',
          answer: 'The LBMA (London Bullion Market Association) Good Delivery Standard is a globally recognised quality seal for precious metals. It guarantees purity, weight and traceability.'
        },
        q3: {
          question: 'How does the savings plan work?',
          answer: 'With our savings plan, you invest a fixed amount monthly in gold and/or silver. This enables the cost-average effect and systematic wealth accumulation.'
        },
        q4: {
          question: 'Can I sell my precious metals back?',
          answer: 'Yes, we offer a buyback guarantee at fair daily prices. Your investment remains liquid and can be sold at any time.'
        }
      },
      cta: 'Contact Us',
      viewProducts: 'View Our Products'
    },
    contact: {
      title: 'Contact Us',
      subtitle: 'Do you have questions about our products or would you like a personal consultation? We are here for you.',
      form: {
        title: 'Send Us a Message',
        name: 'Your Name',
        email: 'Your Email',
        phone: 'Phone Number (optional)',
        subject: 'Subject',
        message: 'Your Message',
        submit: 'Send Message',
        sending: 'Sending...',
        success: 'Thank you! We will get back to you shortly.',
        error: 'An error occurred. Please try again.'
      },
      info: {
        title: 'Contact Information',
        phone: 'Phone',
        email: 'Email',
        address: 'Address',
        hours: 'Opening Hours',
        hoursValue: 'Mon–Fri: 9:00 AM – 5:00 PM'
      },
      trust: {
        fast: {
          title: 'Fast Response',
          description: 'We respond to your enquiry within 24 hours'
        },
        individual: {
          title: 'Individual Consultation',
          description: 'Personal consultation on your savings plan options'
        },
        competent: {
          title: 'Competent Support',
          description: 'Experienced experts will answer all your questions'
        }
      }
    },
    footer: {
      company: 'Your trusted partner for gold and silver since 2010.',
      navigation: 'Navigation',
      services: 'Services',
      copyright: 'All rights reserved.',
      imprint: 'Imprint',
      contact: 'Contact',
      privacy: 'Privacy Policy',
      deliveryPayment: 'Delivery & Payment Terms'
    },
    privacy: {
      title: 'Privacy Policy',
      subtitle: 'Your privacy is important to us. Here you will find out how we protect and process your data.',
      intro: {
        title: 'Introduction',
        content1: 'The protection of your personal data is particularly important to us. We process your data exclusively on the basis of legal provisions (GDPR, TKG 2003).',
        content2: 'In this privacy policy, we inform you about the most important aspects of data processing in the context of our website and our services.'
      },
      controller: {
        title: 'Data Controller',
        email: 'Email',
        phone: 'Phone'
      },
      collection: {
        title: 'What Data We Collect',
        intro: 'We collect and process the following personal data:',
        item1: 'Contact data (name, email address, phone number)',
        item2: 'Address data for deliveries',
        item3: 'Payment information',
        item4: 'Communication data (enquiries, messages)',
        item5: 'Technical data (IP address, browser information, access times)'
      },
      purpose: {
        title: 'Purpose of Data Processing',
        intro: 'We use your data for the following purposes:',
        item1: 'Processing orders and contracts',
        item2: 'Customer service and responding to enquiries',
        item3: 'Shipping of products',
        item4: 'Fulfilment of legal obligations',
        item5: 'Improvement of our services'
      },
      legal: {
        title: 'Legal Basis',
        content1: 'The processing of your data is based on Art. 6 Para. 1 GDPR:',
        content2: 'a) Consent (Art. 6 Para. 1 lit. a GDPR) – You have given us your explicit consent to processing.',
        content3: 'b) Contract fulfilment (Art. 6 Para. 1 lit. b GDPR) – Processing is necessary for the fulfilment of a contract.'
      },
      retention: {
        title: 'Retention Period',
        content1: 'We store your personal data only for as long as is necessary to fulfil the respective purposes or to comply with statutory retention periods.',
        content2: 'After these periods expire, the data is routinely deleted, provided no further processing is required.'
      },
      rights: {
        title: 'Your Rights',
        intro: 'You have the following rights regarding your personal data:',
        access: 'Right of Access',
        accessDesc: 'You have the right to obtain information about your stored data.',
        rectification: 'Right to Rectification',
        rectificationDesc: 'You can request the correction of inaccurate data.',
        erasure: 'Right to Erasure',
        erasureDesc: 'You can request the deletion of your data, provided no statutory retention obligations exist.',
        restriction: 'Restriction of Processing',
        restrictionDesc: 'You can request the restriction of the processing of your data.',
        portability: 'Data Portability',
        portabilityDesc: 'You have the right to receive your data in a structured format.',
        objection: 'Right to Object',
        objectionDesc: 'You can object to the processing of your data.'
      },
      security: {
        title: 'Data Security',
        content1: 'We use appropriate technical and organisational security measures to protect your data from accidental or intentional manipulation, loss, destruction or access by unauthorised persons.',
        content2: 'Our security measures are continuously improved in line with technological developments.'
      },
      cookies: {
        title: 'Cookies',
        content1: 'Our website uses cookies to improve usability. Cookies are small text files stored on your device.',
        content2: 'You can configure your browser to notify you about the setting of cookies and to allow cookies only in individual cases or to generally exclude the acceptance of cookies.'
      },
      contact: {
        title: 'Contact',
        content: 'If you have any questions about data protection, you can contact us at any time:'
      },
      lastUpdated: 'Last updated'
    },
    deliveryAndPayment: {
      title: 'Delivery & Payment Terms',
      section1: {
        title: '1. Scope',
        content: 'These delivery and payment terms apply to all orders of precious metals (gold and silver) from GOLD DREAMS. By placing an order, you acknowledge these terms as binding.'
      },
      section2: {
        title: '2. Order and Contract Conclusion',
        content1: 'Orders can be placed by phone at +49 (0) 6359 86762 / +49 (0) 172 297 30 22, by email at info@golddreams.eu or via our contact form.',
        content2: 'After receiving your order, you will receive an order confirmation by email. The contract is concluded upon dispatch of this confirmation.',
        content3: 'The stated prices are based on the current market price at the time of the order and are exclusive of statutory VAT.'
      },
      section3: {
        title: '3. Prices',
        content: 'All prices are updated daily and are based on the current gold or silver price. The prices valid at the time of the order are binding. Prices are stated in euros and include statutory VAT.'
      },
      section4: {
        title: '4. Payment Terms',
        content1: 'We accept the following payment methods:',
        item1: 'Bank transfer (advance payment)',
        item2: 'Cash payment on collection (by arrangement)',
        content2: 'Delivery takes place only after receipt of full payment in our account.'
      },
      section5: {
        title: '5. Delivery and Shipping',
        content1: 'Delivery is made insured and discreetly packaged to the delivery address you have provided. The delivery time is generally 3–5 working days after receipt of payment.',
        content2: 'Shipping costs are included in the product price. For larger orders or savings plans, shipping is free of charge.'
      },
      section6: {
        title: '6. Buyback Guarantee',
        content1: 'We guarantee the buyback of all precious metals purchased from us at our current daily prices.',
        content2: 'Contact us for a non-binding buyback offer.'
      },
      section7: {
        title: '7. Liability and Warranty',
        content: 'All products are LBMA-certified and delivered with a certificate of authenticity. We are liable for material and manufacturing defects in accordance with statutory provisions. Complaints must be submitted in writing immediately upon receipt of the goods.'
      }
    },
    imprint: {
      title: 'Imprint',
      section1: {
        title: 'Information pursuant to § 5 TMG',
        company: 'GOLD DREAMS',
        legalForm: 'Sole trader',
        address: 'Hauptstraße 123',
        city: '67346 Speyer',
        country: 'Germany'
      },
      section2: {
        title: 'Contact',
        phone: 'Phone',
        phoneValue: '+49 (0) 6359 86762',
        mobile: 'Mobile',
        mobileValue: '+49 (0) 172 297 30 22',
        email: 'Email',
        emailValue: 'info@golddreams.eu'
      },
      section3: {
        title: 'VAT Identification Number',
        content: 'VAT identification number pursuant to § 27a of the Value Added Tax Act:',
        vatId: ''
      },
      section4: {
        title: 'Professional Title',
        profession: 'Professional title',
        professionValue: 'Precious metals dealer',
        country: 'Awarded in',
        countryValue: 'Germany'
      },
      section5: {
        title: 'EU Dispute Resolution',
        content: 'The European Commission provides a platform for online dispute resolution (ODR):',
        link: 'https://ec.europa.eu/consumers/odr',
        email: 'Our email address can be found above in the imprint.'
      },
      section6: {
        title: 'Consumer Dispute Resolution',
        content: 'We are not willing or obliged to participate in dispute resolution proceedings before a consumer arbitration board.'
      }
    }
  }
};